<template>
    <div class="content-box">
      <div class="content-wrapper">
        <h2 class="cont-head">{{  selectedLesson.title || 'לא הוספו שיעורים'}}</h2>
        <div v-if="selectedLesson.content" class="rich-txt w-richtext" v-html="selectedLesson.content"></div>
            <lessonForum />

      </div>
      <div class="files-box">
        <p class="paragraph" v-if="this.filesExists">
          קבצים מצורפים
          <br />
        </p>
        <div v-for="item in selectedLesson.file" :key="item._id">
          <a
            :href="item.imageURL+'&download=true'"
            target="_blank"
            download="true"
            class="download-btn w-button"
          >{{item.altText}}</a>
        </div>
      </div>
  </div>
</template>

<script>
import lessonForum from "../components/lessonForum";
import {mapActions} from "vuex";

export default {
  name: "lessonBody",
      components: { lessonForum },
  computed: {
    selectedLesson() {
      return this.$store.getters.getSelectedLesson;
    },
    selectedPath(){
      return this.$store.getters.getSelectedPath;
    },
    filesExists(){
      return this.selectedLesson.file > 0;
    }
  },

  async mounted() {
    await this.fetchSelectedPath(this.$route.params.id);
    if (this.$route.params.lessonID){
      await this.setChapter(this.$route.params.chapterID)
      await this.setLesson(this.$route.params.lessonID);
      await this.fetchComments;
    }

  },
  beforeRouteUpdate (to, from, next) {
    this.setChapter(to.params.chapterID);
    this.setLesson(to.params.lessonID);
    next();
  },
  methods: {
    // orderNum(ordNum){
    //   return ordNum + 1;
    // },
    async setLesson(chapterClassId) {
      this.selectedClass = this.$store.getters.getLessonById(chapterClassId);
      if (!this.selectedClass) {
        this.$store
                .dispatch("fetchSelectedLesson", chapterClassId)
                .then(() => {
                  this.selectedClass = this.$store.getters.getLessonById(
                          chapterClassId
                  );
                })
                .catch(err => {
                  console.log(err);
                });
      } else {
        this.$store.commit(
                "setLesson",
                this.selectedClass
        );
      }
    },
    async setChapter(chapterId) {
      this.selectedChapter = this.$store.getters.getChapterById(chapterId);
      if (!this.selectedChapter) {
        this.$store
                .dispatch("fetchSelectedChapter", chapterId)
                .then(() => {
                  this.selectedClass = this.$store.getters.getChapterById(
                          chapterId
                  );
                })
                .catch(err => {
                  console.log(err);
                });
      } else {
        await this.$store.commit(
                "setChapter",
                this.selectedChapter
        );
      }
      await this.fetchComments();
    },
    ...mapActions([
      "fetchSelectedPath",
      "setChapterAction",
      "fetchSelectedLesson",
      "fetchComments"
    ])
  },
  watch:{
    getSelectedPath(){
      this.selectedPath = this.getSelectedPath;
    }
  },
};
</script>